import { Table, Header, Box, SpaceBetween, Container, TextContent, Button, ContentLayout, Icon, ColumnLayout, Link } from '@cloudscape-design/components';
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { FaBatteryFull, FaHospital, FaPerson, FaPlane, FaPlaneDeparture } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import API from '../api';
import { useState } from 'react';



const Quotation = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate()



  const [benefits, setBenefits] = useState([])
  const [isBenefitsLoaded, setIsBenefitsLoaded] = useState(false)


    const [flashItems, setFlashItems] = useState([]);


  const data = [
  {
    benefit: t("benefit_region"),
    europe: t("europe_without_uk"),
    world1: t("world_without_usa"),
    world2: t("world_including_usa")
  },
  {
    benefit: t("benefit_medical_level"),
    europe: (<><FaBatteryFull /> {t("full_level")}</>),
    world1: (<><FaBatteryFull /> {t("full_level")}</>),
    world2: (<><FaBatteryFull /> {t("full_level")}</>)
  },
  {
    benefit: t("benefit_transportation"),
    europe: (<><FaPlane /> {t("business_class")}</>),
    world1: (<><FaPlane /> {t("business_class")}</>),
    world2: (<><FaPlane /> {t("first_class")}</>)
  },
  {
    benefit: t("benefit_accommodations"),
    europe: t("star_hotel"),
    world1: t("star_hotel"),
    world2: t("star_hotel")
  },
  {
    benefit: t("benefit_accompanying"),
    europe: (<><FaPerson /> 1</>),
    world1: (<><FaPerson /> 1</>),
    world2: (<><FaPerson /> 1</>)
  },
  {
    benefit: t("benefit_max_limit"),
    europe: "USD 2,000,000",
    world1: "USD 2,000,000",
    world2: "USD 2,000,000"
  },
  {
    benefit: t("benefit_travel_treatment"),
    europe: "USD 30,000 (USD 350/day)",
    world1: "USD 30,000 (USD 350/day)",
    world2: "USD 100,000 (USD 500/day)"
  },
  {
    benefit: t("benefit_pretransplant"),
    europe: "USD 15,000 (USD 350/day)",
    world1: "USD 15,000 (USD 350/day)",
    world2: "USD 25,000 (USD 500/day)"
  },
  {
    benefit: t("benefit_live_donor"),
    europe: "USD 10,000 (USD 350/day)",
    world1: "USD 10,000 (USD 350/day)",
    world2: "USD 20,000 (USD 500/day)"
  },
  {
    benefit: t("benefit_death_transport"),
    europe: "USD 20,000",
    world1: "USD 20,000",
    world2: "USD 50,000"
  },
  {
    benefit: "",
    europe: (<Box textAlign='center'><Button onClick={() => navigate("/get_quote?plan=euro_ex_uk")} variant='primary'>{t("get_instant_quote")}</Button></Box>),
    world1: (<Box textAlign='center'><Button onClick={() => navigate("/get_quote?plan=ww_ex_usa")} variant='primary'>{t("get_instant_quote")}</Button></Box>),
    world2: (<Box textAlign='center'><Button onClick={() => navigate("/get_quote?plan=ww_in_usa")} variant='primary'>{t("get_instant_quote")}</Button></Box>)
  },
];


  const createFlashbarItem = (header, type = "info", content, dismissible = true) => {
    flashItems.forEach((i) => dismissItem(i.id))
    const id = `message_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const newItem = {
      header,
      type,
      content,
      dismissible,
      dismissLabel: "Dismiss message",
      onDismiss: () => dismissItem(id),
      id
    };

    setFlashItems(prevItems => [...prevItems, newItem]);
    return id;
  };


  const dismissItem = (itemId) => {
    setFlashItems(prevItems => prevItems.filter(item => item.id !== itemId));
  };


  const getBenefits = () => {
    setIsBenefitsLoaded(false);
    API.get("/plan/get_benefits")
      .then((response) => {
        response = response.data;
        if (response.operation) {
          setBenefits(response.data);
        } else {
          createFlashbarItem("Error loading plans and benefits", "error", <>Kindly contact <Link href="mailto:it@ilaftakaful.com">ILAF IT</Link> for assistance.</>);
        }
      })
      .catch((error) => {
        console.error(error);
          createFlashbarItem("Error loading plans and benefits()", "error", <>Kindly contact <Link href="mailto:it@ilaftakaful.com">ILAF IT</Link> for assistance.</>);
      })
      .finally(() => {
        setIsBenefitsLoaded(true)
      })

  }

  return (

    <BaseLayout content={
      <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
        <Container>

          <Box padding="s">
            <SpaceBetween size="l">
              <Header variant="h2">{t('table_of_benefits')}</Header>
              <Table
                columnDefinitions={[
                  {
                    id: 'benefit',
                    header: (<TextContent background="gray-100" padding="xs" fontWeight="bold">
                      <strong>
                        {t("benefit_category")}
                      </strong>
                    </TextContent>),
                    cell: item => (<TextContent
                      padding={{ vertical: 'xxs', horizontal: 's' }}
                      background="gray-200"
                      fontWeight="bold"
                      color="text-status-inactive"
                      borderRadius="medium"
                      wrapLines
                    >
                      {item.benefit}
                    </TextContent>),
                    maxWidth: 100
                  },
                  {
                    id: 'europe',
                    header: t("europe_plan"),
                    cell: item => item.europe,
                    minWidth: 150
                  },
                  {
                    id: 'world1',
                    header: t("world_plan_1"),
                    cell: item => item.world1,
                    minWidth: 150
                  },
                  {
                    id: 'world2',
                    header: t("world_plan_2"),
                    cell: item => item.world2,
                    minWidth: 150
                  }
                ]}
                items={data}
                stickyHeader={true}
                variant="bordered"
              />
              <Box fontSize="body-s" color="text-body-secondary">
                {t("footer_note_1")} <br />
                {t("footer_note_2")}
              </Box>
            </SpaceBetween>
          </Box>
        </Container>

      </div>
    } />
  );
};

export default Quotation;
